@if (!embedded) {
  <div class="page-header">
    <div>
      <h1>{{ scope === 'global' ? t('GlobalLabelsPageLink') : t('HubProcessTranslationsTitle') }}</h1>
      <p>{{ scope === 'global' ? t('HubGlobalTranslationsIntro') : t('HubProcessTranslationsIntro') }}</p>
    </div>
    @if (scope === 'global') {
      <button class="primary-button" type="button" (click)="createModalOpen = true">{{ t('HubAddTranslationLabel') }}</button>
    }
  </div>
}

@if (error) {
  <p class="message error">{{ error }}</p>
}
@if (success) {
  <p class="message success">{{ success }}</p>
}
@if (loading) {
  <p>{{ t('HubTranslationsLoading') }}</p>
}

@if (!loading && data) {
  <div class="translations-toolbar">
    <button class="secondary-button" type="button" (click)="exportTranslations()"><wa-icon name="download"></wa-icon>{{ t('HubExportTranslations') }}</button>
    <button class="secondary-button" type="button" [disabled]="importing" (click)="importFileInput.click()"><wa-icon name="upload"></wa-icon>{{ importing ? t('HubTranslationImporting') : t('HubImportTranslations') }}</button>
    <input #importFileInput type="file" accept=".json,application/json" hidden (change)="onImportFileSelected($event)">
    <button class="secondary-button" type="button" [disabled]="bulkRunning || untranslatedCount() === 0" [title]="untranslatedCount() === 0 ? t('HubBulkTranslateAllDoneTooltip') : ''" (click)="startBulkTranslate()"><wa-icon name="wand-magic-sparkles"></wa-icon>{{ t('HubBulkTranslateButton') }}{{ untranslatedCount() > 0 ? ' (' + untranslatedCount() + ')' : '' }}</button>
  </div>
  <div class="card translations-card">
    <table class="table">
      <thead>
        <tr><th class="expander-column"></th><th>{{ t('LabelLabel') }}</th><th>{{ t('LabelTranslations') }}</th><th>{{ t('HubStatus') }}</th></tr>
      </thead>
      <tbody>
        @for (entry of data.translations; track entry) {
          <tr class="translation-row" (click)="toggle(entry.label)">
            <td class="expander-column" data-label=""><span class="expander-icon" [class.open]="openedLabel === entry.label">▶</span></td>
            <td [attr.data-label]="t('LabelLabel')">{{ entry.label }}</td>
            <td [attr.data-label]="t('LabelTranslations')">
              @for (language of data.languages; track language) {
                <span class="language-state" [class.missing]="!entry.translations[language]">{{ language }}</span>
              }
            </td>
            <td class="status-cell" [attr.data-label]="t('HubStatus')">
              <span class="status-icons" [title]="statusLabel(entry)">
                @if (entry.allTranslated) {
                  <wa-icon class="status-icon complete" name="check-circle" [attr.aria-label]="t('HubComplete')"></wa-icon>
                }
                @if (entry.format === 'markdown') {
                  <wa-icon class="status-icon markdown" name="markdown" aria-label="Markdown"></wa-icon>
                }
                @if (entry.system) {
                  <wa-icon class="status-icon system" name="lock" [attr.aria-label]="t('HubSystemLabel')"></wa-icon>
                }
              </span>
              @if (scope === 'global' && !entry.system) {
                <button class="danger-button" type="button" (click)="$event.stopPropagation(); deleteGlobalLabel(entry)">{{ t('Delete') }}</button>
              }
            </td>
          </tr>
          @if (openedLabel === entry.label) {
            <tr class="translation-editor-row">
              <td colspan="4">
                <div class="form-grid">
                  <label>{{ t('labelFormat') }}
                    <select [(ngModel)]="entry.format" [name]="entry.label + '-format'">
                      <option value="text">Text</option>
                      <option value="markdown">Markdown</option>
                    </select>
                  </label>
                  @for (language of data.languages; track language) {
                    <label>
                      <span class="translation-language-header">
                        <span>{{ data.languageNames[language] || language }}</span>
                        <button class="secondary-button compact-button" type="button" [disabled]="!canAutoTranslate(entry, language)" (click)="autoTranslate(entry, language)">
                          {{ isTranslating(entry, language) ? t('HubTranslating') : t('translateLabelsAutomatically') }}
                        </button>
                      </span>
                      <textarea [name]="entry.label + '-' + language" [(ngModel)]="entry.translations[language]" [class.markdown]="entry.format === 'markdown'"></textarea>
                    </label>
                  }
                  <button class="primary-button" type="button" (click)="save(entry)"><wa-icon name="floppy"></wa-icon>{{ t('HubSaveTranslation') }}</button>
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
}

@if (importModalOpen && importReport) {
  <div class="modal-backdrop" (click)="!importing && closeImportModal()">
    <div class="modal-card import-modal" (click)="$event.stopPropagation()">
      <h2>{{ t('HubImportTranslations') }}</h2>
      <p>{{ importCountText('HubTranslationImportChangedCount', importReport.updated.length) }}</p>
      @if (importReport.updated.length > 0) {
        <p class="import-detail">{{ importReport.updated.join(', ') }}</p>
      }
      <p>{{ importCountText('HubTranslationImportUnchangedCount', importReport.unchanged.length) }}</p>
      @if (importReport.skippedLabels.length > 0) {
        <p class="import-detail">{{ t('HubTranslationImportSkippedLabels') }} {{ importReport.skippedLabels.join(', ') }}</p>
      }
      @if (importReport.warnings.length > 0) {
        <ul class="import-warnings">
          @for (warning of importReport.warnings; track warning) {
            <li>{{ warning }}</li>
          }
        </ul>
      }
      @if (importReport.updated.length === 0) {
        <p>{{ t('HubTranslationImportNoChanges') }}</p>
      }
      <div class="button-row">
        <button class="secondary-button" type="button" [disabled]="importing" (click)="closeImportModal()">{{ t('DeleteFormCancelButtonLabel') }}</button>
        <button class="primary-button" type="button" [disabled]="importing || importReport.updated.length === 0" (click)="applyImport()">{{ importing ? t('HubTranslationImporting') : t('HubTranslationImportApply') }}</button>
      </div>
    </div>
  </div>
}

@if (bulkModalOpen) {
  <div class="modal-backdrop">
    <div class="modal-card" (click)="$event.stopPropagation()">
      <h2>{{ t('HubBulkTranslateTitle') }}</h2>
      <div class="bulk-progress-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="bulkProgressPercent()">
        <div class="bulk-progress-fill" [style.width.%]="bulkProgressPercent()"></div>
      </div>
      <p class="bulk-progress-text">{{ bulkProgressText() }}</p>
      @if (bulkRunning && bulkCurrentLabel) {
        <p class="bulk-current">{{ bulkCurrentText() }}</p>
      }
      @if (bulkRunning && bulkRetryInSeconds > 0) {
        <p class="bulk-retry">{{ bulkRetryText() }}</p>
      }
      @if (bulkFinished) {
        <p>{{ bulkAborted ? t('HubBulkTranslateAbortedMessage') : (bulkCancelRequested ? t('HubBulkTranslateCancelledMessage') : t('HubBulkTranslateDoneMessage')) }}</p>
        @if (bulkFailed.length > 0) {
          <p class="import-detail">{{ t('HubBulkTranslateFailedItems') }} {{ bulkFailed.join(', ') }}</p>
        }
      }
      <div class="button-row">
        @if (bulkRunning) {
          <button class="secondary-button" type="button" [disabled]="bulkCancelRequested" (click)="cancelBulkTranslate()">{{ bulkCancelRequested ? t('HubBulkTranslateCancelling') : t('DeleteFormCancelButtonLabel') }}</button>
        } @else {
          <button class="primary-button" type="button" (click)="closeBulkModal()">{{ t('HubClose') }}</button>
        }
      </div>
    </div>
  </div>
}

@if (createModalOpen) {
  <div class="modal-backdrop" (click)="createModalOpen = false">
    <form class="modal-card" (click)="$event.stopPropagation()" (ngSubmit)="createGlobalLabel()">
      <h2>{{ t('HubAddTranslationLabel') }}</h2>
      <label>{{ t('LabelLabel') }}<input name="newLabel" [(ngModel)]="newLabel" placeholder="global_newLabelName" required></label>
      <div class="button-row">
        <button class="secondary-button" type="button" (click)="createModalOpen = false">{{ t('DeleteFormCancelButtonLabel') }}</button>
        <button class="primary-button" type="submit">{{ t('HubCreate') }}</button>
      </div>
    </form>
  </div>
}
